import React, { useEffect, useReducer } from "react";
import {
  Box,
  Alert,
  AlertTitle,
  Tooltip,
  IconButton,
  Switch,
  FormControlLabel,
  TextField,
  Button,
} from "@mui/material";
import { getSession } from "../../auth.js";
import api from "../../api.js";
import Loading from "../Loading/index.js";
import LoadingButton from "@mui/lab/LoadingButton";
import AddProductForm from "./Pages/AddProductForm/index.js";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  gridClasses,
  ptBR,
} from "@mui/x-data-grid-pro";
import { ptBR as corePtBR } from "@mui/material/locale";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import defaultReducer from "../../utils/defaultReducer.js";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import useNotification from "../Notification";
import ConfirmationDialog from "../Dialogs/Confirmation/index.js";

import ContentUnavailable from "../ContentUnavailable"
import ScoutLogo from "../../assets/images/kwik-scout-logo.png"
import { useMenu } from "../../contexts/MenuContext"

let variable_enterprise = null;

const theme = createTheme(
  {
    palette: {
      primary: { main: "#21446C" },
    },
  },
  ptBR,
  corePtBR
);

const defColumns = (state, setState) => {
  const columns = [];
  columns.push({ field: "name", headerName: "Nome", flex: 1 });
  columns.push({ field: "description", headerName: "Descrição", flex: 1 });

  columns.push({
    field: "actions",
    headerName: "Ações",
    flex: 1,
    renderCell: ({ row }) => (
      <>
        <Tooltip title="Editar">
          <Button
            className="action-button"
            onClick={() =>
              setState({
                showFormModal: true,
                edit_id: row.id,
                edit_name: row.name,
                edit_description: row.description,
              })
            }
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Excluir">
          <Button
            className="action-button delete"
            onClick={() => setState({
              showDeleteModal: true,
              edit_id: row.id,
              edit_name: row.name,
            })}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    ),
  });
  return columns;
};

const getProducts = async (setState) => {
  const user = getSession();
  setState({ loading: true });
  try {
    const res = await api.get(
      `api/enterprises/${variable_enterprise.id}/scout_products/`
    );
    if (res.status === 200) {
      setState({ products: res.data });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setState({ loading: false });
  }
};

const saveProduct = async (id, name, description, setState) => {
  setState({ loading: true });
  const payload = {
    name: name,
    description: description,
  };
  let res;
  if (id !== null) {
    res = await api.patch(
      `api/enterprises/${variable_enterprise.id}/scout_products/${id}/`,
      payload
    );
  } else {
    res = await api.post(
      `api/enterprises/${variable_enterprise.id}/scout_products/`,
      payload
    );
  }
  setState({ loading: false });
  if (res && [200, 201].includes(res.status)) {
    useNotification(
      "Sucesso!",
      `Automação ${id === 0 ? "criada" : "alterada"} com sucesso!`,
      "success"
    );
    getProducts(setState);
    setState({
      showFormModal: false,
      edit_id: null,
      edit_name: "",
      edit_description: "",
    });
    return;
  } else {
    let messageError =
      res.data?.detail ||
      res.data?.error ||
      res.data?.message ||
      `Falha ao ${id === null ? "criar" : "editar"} produto [${res.status}].`;

    useNotification("Ops.", messageError, "danger");
  }

  return;
};

const deleteProduct = async (id, setState) => {
  setState({ loading: true });
  const res = await api.delete(
    `api/enterprises/${variable_enterprise.id}/scout_products/${id}/`
  );
  setState({ loading: false });

  if (res && res.status === 204) {
    useNotification("Sucesso!", "Produto excluído com sucesso!", "success");
    getProducts(setState);
    setState({
      showDeleteModal: false,
      edit_id: null,
      edit_name: "",
      edit_description: "",
    });
    return;

  } else {
    let messageError =
      res.data?.detail ||
      res.data?.error ||
      res.data?.message ||
      `Falha ao excluir produto [${res.status}].`;
    useNotification("Ops.", messageError, "danger");

  }

  return;
};

const CustomToolbar = (setState) => {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <LoadingButton
        size="small"
        component="label"
        startIcon={<AddCircleIcon />}
        onClick={() => {
          setState({ showFormModal: true });
        }}
      >
        Adicionar
      </LoadingButton>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
};

const ProductsAndServicesPage = () => {
  const { configurableUrls } = useMenu()
  const enterprise = getSession().profile.enterprise;
  variable_enterprise = enterprise;
  const [state, setState] = useReducer(defaultReducer, {
    products: [],
    loading: false,
    showFormModal: false,
    showDeleteModal: false,
    edit_id: null,
    edit_name: "",
    edit_description: "",
  });

  useEffect(() => {
    getProducts(setState);
  }, []);

  if (enterprise.platforms.scout) {
    if (!enterprise.platforms.scout_ai) {
      return (
        <ContentUnavailable
            icon={<img src={ScoutLogo} alt="Kwik Scout" style={{ width: 350 }} />}
            title="Recurso indisponível para sua conta."
            description={
                <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                    Para contratar o módulo de Inteligência Artifical do Scout, clique aqui.
                </a>
            }
        />
      );
    }
    return (
      <Box className="input-settings settings-body">
        <Box className="settings-flexcolumn">
          <Loading loading={state.loading} />
          <Alert className="telegram-info" severity="info">
            <AlertTitle>
              Para saber como utilizar o cardápio de produtos e serviços{" "}
              <a
                href="https://instant.getoutline.com/s/kwik-integracoes/doc/scout-Bmj6w7Jccq"
                target="_blank"
              >
                clique aqui.
              </a>
            </AlertTitle>
            <Box className="push-s-top">Clique no botão Adicionar</Box>
          </Alert>
          <Box className="settings-body-bot">
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <DataGridPro
                  pageSize={100}
                  pagination
                  disableSelectionOnClick
                  disableDensitySelector
                  density="compact"
                  columns={defColumns(state, setState)}
                  rows={state.products}
                  components={{
                    Toolbar: () => CustomToolbar(setState),
                  }}
                />
              </ThemeProvider>
            </StyledEngineProvider>
          </Box>
        </Box>
        {state.showFormModal && (
          <AddProductForm
            open={true}
            handleClose={() =>
              setState({
                showFormModal: false,
                edit_id: null,
                edit_name: "",
                edit_description: "",
              })
            }
            submit={(...args) => saveProduct(...args, setState)}
            edit_id={state.edit_id}
            edit_name={state.edit_name}
            edit_description={state.edit_description}
          />
        )}
            <ConfirmationDialog open={state.showDeleteModal}
                title="Confirmação"
                description={`Tem certeza que deseja excluir o produto  ${state.edit_name}?`}
                handleClose={() => { setState({ showDeleteModal: false }) }}
                handleSubmit={() => deleteProduct(state.edit_id, setState)}
            />
      </Box>
    );
  } else {
    return (
      <Box>
        <Alert severity="info">
          Entre em contato com seu gerente de contas para contratar o Kwik Scout
          - O canal de "Compliance" e gravacao de WhatsApp do Kwik -{" "}
          <a href="https://wa.link/0bs73j">Clique aqui.</a>
        </Alert>
      </Box>
    );
  }
};

export default ProductsAndServicesPage;
